module.exports = __webpack_public_path__ + "static/media/app-marketplace.39bbec23.png";